export default function () {
	return {
		accept_terms_and_conditions: '',
		access_token: '',
		admin_left_menu: false,
		device_token: '',
		email: '',
		email_unsubscribe: false,
		full_name: '',
		created_at: '',
		has_mandatory_surveys: false,
		has_mandatory_drills: false,
		has_close_banner_drills: true,
		document: '',
		birthday: '',
		phone_mobile_number: '',
		id: '',
		id_user_client_country_selected: '',
		id_user_client_profile: '',
		id_user_client_selected: '',
		id_user_language_selected: '',
		is_superuser: false,
		user_language_selected: '',
		left_menu: false,
		refresh_token: '',
		reload_content: false,
		right_menu: false,
		status: '',
		user_branches: [],
		user_change_password: false,
		user_client_module_items: [],
		user_clients: [],
		user_countries: [],
		user_firebase_document: '',
		user_firebase_document_ranking_areas: [],
		user_firebase_token: '',
		user_image: '',
		user_reward_campaign: {},
		webservice_token: '',
		redirect_url: {},
		accept_cookies_policy: '',
		date_request_set_user_data: '',
		must_change_password: false,
		set_locale_processed: false,
		verificacion_phone_button: {}
	}
}
